import { HashRouter as Router, Routes, Route } from "react-router-dom";
import ExChange from "./exChange";
import ExChangeDetail from "./exChangeDetail";
import ConfigPage from "./configPage";
import LuckyRecord from "./luckyRecord";
import ActivityDetail from "./activityDetail";
import ActivityDetailPage from "./activityDetailPage";
import MyTeam from "./myTeam";
import RankingLuckyRecord from "./rankingLuckyRecord";
import DetailPage from "./detailPage";
import RankingDetail from "./configPage/components/ranking/rankingDetail";
import ExpiredPage from "./expired-page";

import "./index.less";
import { useEffect } from "react";
import Cookie from "js-cookie";
import { getQueryHashString } from "@/utils/url";
import useScrollPassIssue from "@/hooks/useScrollPassIssue";
function App() {
  useScrollPassIssue();

  // 开发模式配置
  useEffect(() => {
    const mode = import.meta.env.MODE;
    console.log("本地开发模式 ===> ", mode);
    if (["test", "uat"].includes(mode)) {
      const uid = getQueryHashString("uid");
      if (uid) {
        Cookie.set("wasxuid_r", uid);
        Cookie.set("isTest", true);
      }
    } else {
      Cookie.set("isTest", "");
    }
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ExChange />} />
        <Route path="/exChange" element={<ExChange />} />
        <Route path="/exChangeDetail" element={<ExChangeDetail />} />
        <Route path="/configPage" element={<ConfigPage />} />
        <Route path="/luckyRecord" element={<LuckyRecord />} />
        <Route path="/activityDetail" element={<ActivityDetail />} />
        <Route path="/activityDetailPage" element={<ActivityDetailPage />} />
        <Route path="/myTeam" element={<MyTeam />} />
        <Route path="/rankingLuckyRecord" element={<RankingLuckyRecord />} />
        <Route path="/detailPage" element={<DetailPage />} />
        <Route path="/rankingDetail" element={<RankingDetail />} />
        <Route path="/expiredPage" element={<ExpiredPage />} />
      </Routes>
    </Router>
  );
}

export default App;
